import { classNames } from "../../../helpers/cssClassHelper"
import "./Card.scss"
import React from 'react'

interface CardProps {
    children: React.ReactNode
    className?: string
    padding?: "0" | "05" | 1 | 2
    margin?: "0" | "05" | 1 | 2
    borderRadius?: "small" | "medium"
    width?: string
    height?: string
    maxWidth?: number | string
    minHeight?: number | string
    style? : React.CSSProperties
}

const Card: React.FC<CardProps> = (props) => {
    const className = classNames(
        'card',
        props.className,
        props.borderRadius ? `border-radius-${props.borderRadius}` : 'border-radius-medium',
        props.padding ? `p-${props.padding}` : '',
        props.margin ? `m-${props.margin}` : 'm-05'
    )

    const style = {
        width: props.width ?? '',
        height: props.height ?? '',
        maxWidth: props.maxWidth ?? '',
        minHeight: props.minHeight ?? '',
        ...props.style
    }

    return <div className={className} style={style}>
        {props.children}
    </div>
}

export default Card
